var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMessageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.1746H9.61079L12.6595 22.4422C12.8234 22.619 13.0182 22.7593 13.2327 22.855C13.4473 22.9507 13.6773 23 13.9097 23C14.0626 22.9997 14.2148 22.9788 14.3628 22.9377C14.6619 22.8567 14.9358 22.6926 15.157 22.4618C15.3781 22.231 15.5387 21.9418 15.6225 21.6232L21 2L5 19.1746Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80983 18L21 0L1.38358 6.05679C1.06418 6.15189 0.774072 6.33277 0.542047 6.58148C0.310022 6.83019 0.144142 7.13809 0.060864 7.47464C-0.0224143 7.81119 -0.0201966 8.16468 0.0672972 8.50005C0.154791 8.83543 0.32452 9.14102 0.559645 9.38652L3.80983 12.7863V18Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMessageActive);
export default __webpack_public_path__ + "static/media/footer-message-active.9bdbe8b2e318f4c16b1edbc7bd241120.svg";
export { ForwardRef as ReactComponent };